import React from 'react';
import ReactDOM from 'react-dom';

import './shared/styles/globals.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker.js';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

registerServiceWorker();
reportWebVitals();
